var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-action',[_c('kst-action-item',[_c('kst-button',{attrs:{"action-mode":"","module":_vm.Model.Item.Module,"moduleType":_vm.Model.Item.ModuleType.Edit,"urlParams":_vm.urlParams}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }